import _axios from "axios"
import { endpoints } from "../../public/config"

const axios = _axios

axios.create({
    timeout: 10000,
    headers: {
        get: {
            "Accept": "application/json"
        },
    }
});

export default {
    get(params) {
        return axios.get(endpoints.lbcApiUrl, {params})
    }
}
